import { Fragment, useEffect, useMemo, useRef, useState } from 'react';
import { Button, Card, Col, Form, Row, Table, Badge } from 'react-bootstrap';
import Select, { components } from 'react-select';
import CurrencyInput from 'react-currency-input-field';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { editarBreadcrumb } from '../../actions/breadcrumb';

import AgregarClienteModal from './modals/AgregarClienteModal';
import PreciosProveedorModal from './modals/PreciosProveedorModal';
import SeleccionUbicacionesModal from './modals/SeleccionUbicacionesModal';
import ConvertirVentaModal from './modals/ConvertirVentaModal';
import DevolverProductoVentaModal from './modals/DevolverProductoVentaModal';
import SeleccionPaqueteModal from './modals/SeleccionPaqueteModal';
import DevolverPaqueteVentaModal from './modals/DevolverPaqueteVentaModal';

import { setAlert } from '../../actions/alert';
import {
    buscarClientesVenta,
    crearClienteVenta,
    listarMetodosVenta,
    listarProductosVenta,
    cargarVentaEdicion,
    limpiarVentaEdicion,
    editarVenta,
    cargarCategoriasVenta,
    cargarSubcategoriasVenta,
    limpiarSubcategoriasVenta,
    buscarProductosInventarioVenta,
    limpiarProductosInventarioVenta,
    cargarDetalleProductoVenta,
    limpiarDetalleProductoVenta,
    generarPdfVenta
} from '../../actions/ventas';
import { buscarPaquetes, limpiarPaquetes } from '../../actions/configuracion';

const TIPO_OPTIONS = [
    { value: 0, label: 'Venta' },
    { value: 1, label: 'Cotización' }
];

const buildUbicacionLabel = (p) => {
    const parts = [];
    if (p?.area?.nombre) parts.push(p.area.nombre);
    if (p?.organizador?.nombre) parts.push(p.organizador.nombre);
    if (p?.ubicacion?.nombre) parts.push(p.ubicacion.nombre);
    return parts.join(' / ');
};

const buildRowKey = (p) => {
    const a = p?.area?._id || 'na';
    const o = p?.organizador?._id || 'null';
    const u = p?.ubicacion?._id || 'null';
    return `${p?._id || 'np'}-${a}-${o}-${u}`;
};

const buildRowKeyFromIds = (productoId, areaId, organizadorId, ubicacionId) => {
    const a = areaId || 'na';
    const o = organizadorId || 'null';
    const u = ubicacionId || 'null';
    return `${productoId || 'np'}-${a}-${o}-${u}`;
};

const formatMoney = (value) => {
    const v = Number(value || 0);
    return new Intl.NumberFormat('en-US', { minimumFractionDigits: 3, maximumFractionDigits: 3 }).format(v);
};

const formatNumber = (value) => {
    const v = Number(value || 0);
    return new Intl.NumberFormat('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(v);
};

const buildProductoPayload = (it) => ({
    producto: it.productoId,
    unidad: it.unidadId || null,
    cantidad: Number(it.cantidad || 0),
    precio: Number(it.precio || 0),
    conversion: Number(it.conversion || 1),
    area: it.areaId || null,
    organizador: it.organizadorId || null,
    ubicacion: it.ubicacionId || null,
    iva: it.iva || false
});

const NoOptionsClientes = (props) => {
    const inputValue = (props.selectProps.inputValue || '').trim();
    const isLoading = !!props.selectProps.isLoading;

    if (!inputValue) {
        return (
            <components.NoOptionsMessage {...props}>
                Escribe para buscar
            </components.NoOptionsMessage>
        );
    }

    if (isLoading) {
        return (
            <components.NoOptionsMessage {...props}>
                Buscando...
            </components.NoOptionsMessage>
        );
    }

    return (
        <components.NoOptionsMessage {...props}>
            <div className="text-muted mb-2">Sin resultados</div>
            <button
                type="button"
                className="btn btn-outline-primary btn-sm w-100"
                onMouseDown={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    if (typeof props.selectProps.onAgregarCliente === 'function') {
                        props.selectProps.onAgregarCliente();
                    }
                }}
            >
                Agregar nuevo cliente
            </button>
        </components.NoOptionsMessage>
    );
};

export default function EditarVenta() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { id } = useParams();

    const {
        metodos,
        categoriasVenta,
        subcategoriasVenta,
        productosInventario,
        ventaEdicion
    } = useSelector((state) => state.ventas);

    const { listado: paquetesBusqueda } = useSelector((state) => state.configuracion?.paquetes || { listado: [] });

    const [clienteSeleccionado, setClienteSeleccionado] = useState(null);
    const [clienteInput, setClienteInput] = useState('');
    const [clientesEncontrados, setClientesEncontrados] = useState([]);
    const [loadingClientes, setLoadingClientes] = useState(false);
    const [showNuevoCliente, setShowNuevoCliente] = useState(false);
    const [savingCliente, setSavingCliente] = useState(false);
    const [fechaVenta, setFechaVenta] = useState(new Date());

    const [tipoSeleccionado, setTipoSeleccionado] = useState(null);
    const [metodoSeleccionado, setMetodoSeleccionado] = useState(null);
    const [cobroInmediato, setCobroInmediato] = useState(true);
    const [moneda, setMoneda] = useState(0);
    const [tipoCambioUsd, setTipoCambioUsd] = useState('1');

    const [categoriaSel, setCategoriaSel] = useState(null);
    const [subcategoriaSel, setSubcategoriaSel] = useState(null);
    const [codigoTienda, setCodigoTienda] = useState('');
    const [codigoProveedor, setCodigoProveedor] = useState('');
    const [nombreBusquedaInput, setNombreBusquedaInput] = useState('');
    const [buscandoProductos, setBuscandoProductos] = useState(false);

    const [showUbicaciones, setShowUbicaciones] = useState(false);
    const [detalleActual, setDetalleActual] = useState(null);

    const [items, setItems] = useState([]);

    const [ventaEditadaLocal, setVentaEditadaLocal] = useState(null);

    const [showPreciosProveedor, setShowPreciosProveedor] = useState(false);
    const [preciosContexto, setPreciosContexto] = useState({
        productoNombre: '',
        codigoTienda: '',
        precios: []
    });

    const [showConvertirModal, setShowConvertirModal] = useState(false);
    const [guardandoConvertir, setGuardandoConvertir] = useState(false);
    const [productosConvertirDetalle, setProductosConvertirDetalle] = useState([]);
    const [paquetesConvertirDetalle, setPaquetesConvertirDetalle] = useState([]);
    const [cargandoUbicacionesConvertir, setCargandoUbicacionesConvertir] = useState(false);

    const [showDevolverModal, setShowDevolverModal] = useState(false);
    const [devolverContexto, setDevolverContexto] = useState(null);

    const [busquedaPaquete, setBusquedaPaquete] = useState('');
    const [buscandoPaquetes, setBuscandoPaquetes] = useState(false);
    const [showSeleccionPaquete, setShowSeleccionPaquete] = useState(false);
    const [paqueteActual, setPaqueteActual] = useState(null);
    const [paquetesItems, setPaquetesItems] = useState([]);
    const [paquetesExpandidos, setPaquetesExpandidos] = useState({});
    const [showDevolverPaqueteModal, setShowDevolverPaqueteModal] = useState(false);
    const [devolverPaqueteContexto, setDevolverPaqueteContexto] = useState(null);

    const clientTimerRef = useRef(null);
    const productTimerRef = useRef(null);
    const paqueteTimerRef = useRef(null);
    const metodoPrefillRef = useRef(null);
    const tcRef = useRef(1);

    const disabledAll = !!ventaEditadaLocal;

    // Tipo original del registro cargado (no cambia durante la sesión)
    const tipoOriginal = ventaEdicion?.tipo ?? null;
    const esCotizacionOriginal = tipoOriginal === 1;

    // Tipo actual según el select (solo relevante cuando es cotización original)
    const esCotizacion = tipoSeleccionado?.value === 1;
    /* Sin cliente, el cobro siempre es en el momento (una venta a crédito requiere poder cobrarle a alguien) */
    const esCobradaInmediato = !clienteSeleccionado?.value || cobroInmediato;

    const getTc = () => {
        const tc = Number(tipoCambioUsd);
        return Number.isFinite(tc) && tc > 0 ? tc : 1;
    };

    const validarTipoCambioSiUSD = () => {
        if (Number(moneda) !== 1) return true;
        const tc = Number(tipoCambioUsd);
        return Number.isFinite(tc) && tc > 0;
    };

    const prefMoneda = Number(moneda) === 1 ? 'USD $' : '$';

    /* Al cambiar de moneda, reconvierte los precios ya capturados (manuales o de catálogo)
       usando el tipo de cambio actual, para que no se queden con el número crudo de la otra moneda. */
    const onChangeMoneda = (nextRaw) => {
        const nextVal = Number(nextRaw);
        const prevVal = Number(moneda);
        if (nextVal === prevVal) {
            setMoneda(nextVal);
            return;
        }

        const tc = getTc();

        setItems((prev) => prev.map((it) => {
            let precio = Number(it.precio || 0);
            let precioBase = Number(it.precioBase || 0);

            if (prevVal === 0 && nextVal === 1) {
                precio = precio / tc;
                precioBase = precioBase / tc;
            } else if (prevVal === 1 && nextVal === 0) {
                precio = precio * tc;
                precioBase = precioBase * tc;
            }

            return {
                ...it,
                precio: Number(precio.toFixed(3)),
                precioBase: Number(precioBase.toFixed(6))
            };
        }));

        setPaquetesItems((prev) => prev.map((it) => {
            let precio = Number(it.precio || 0);
            if (prevVal === 0 && nextVal === 1) precio = precio / tc;
            else if (prevVal === 1 && nextVal === 0) precio = precio * tc;
            return { ...it, precio: Number(precio.toFixed(3)) };
        }));

        tcRef.current = tc;
        setMoneda(nextVal);
    };

    /* Si el usuario corrige el tipo de cambio después de haber agregado productos (ej. los agregó
       con el valor default "1" y luego lo ajusta), reescala los precios ya capturados por la razón
       entre el TC anterior y el nuevo — no solo al momento de cambiar de moneda. */
    const onChangeTipoCambio = (nextRaw) => {
        setTipoCambioUsd(nextRaw);

        if (Number(moneda) !== 1) return;

        const nextTc = Number(nextRaw);
        if (!Number.isFinite(nextTc) || nextTc <= 0) return;

        const prevTc = tcRef.current;
        if (nextTc === prevTc) return;

        setItems((prev) => prev.map((it) => {
            const precio = Number(it.precio || 0) * (prevTc / nextTc);
            const precioBase = Number(it.precioBase || 0) * (prevTc / nextTc);
            return {
                ...it,
                precio: Number(precio.toFixed(3)),
                precioBase: Number(precioBase.toFixed(6))
            };
        }));

        setPaquetesItems((prev) => prev.map((it) => ({
            ...it,
            precio: Number((Number(it.precio || 0) * (prevTc / nextTc)).toFixed(3))
        })));

        tcRef.current = nextTc;
    };

    const menuPortalTarget = useMemo(() => {
        if (typeof document === 'undefined') return null;
        return document.body;
    }, []);

    const metodosOptions = useMemo(() => {
        return (Array.isArray(metodos) ? metodos : []).map((m) => ({
            value: m?._id || null,
            label: m?.nombre || ''
        }));
    }, [metodos]);

    const categoriasOptions = useMemo(() => {
        return (Array.isArray(categoriasVenta) ? categoriasVenta : []).map((c) => ({
            value: c?._id || c?.id || null,
            label: c?.nombre || 'Sin definir'
        }));
    }, [categoriasVenta]);

    const subcategoriasOptions = useMemo(() => {
        return (Array.isArray(subcategoriasVenta) ? subcategoriasVenta : []).map((s) => ({
            value: s?._id || s?.id || null,
            label: s?.nombre || 'Sin definir'
        }));
    }, [subcategoriasVenta]);

    const productosOptions = useMemo(() => {
        const arr = Array.isArray(productosInventario) ? productosInventario : [];
        const filtrados = esCotizacion ? arr : arr.filter((p) => Number(p?.cantidad || 0) > 0);
        return filtrados.map((p) => {
            const stock = Number(p?.cantidad || 0);
            const cod = p?.codigo_tienda ? ` · ${p.codigo_tienda}` : '';
            return {
                value: p?._id || null,
                label: `${p?.nombre || ''}${cod} · Stock: ${formatNumber(stock)}`,
                raw: p
            };
        });
    }, [productosInventario, esCotizacion]);

    const clienteOptions = useMemo(() => {
        return (Array.isArray(clientesEncontrados) ? clientesEncontrados : []).map((c) => ({
            value: c?._id || null,
            label: `${c?.nombre || ''}${c?.telefono ? ` (${c.telefono})` : ''}`,
            raw: c
        }));
    }, [clientesEncontrados]);

    const paquetesOptions = useMemo(() => {
        return (Array.isArray(paquetesBusqueda) ? paquetesBusqueda : []).map((p) => ({
            value: p?._id || null,
            label: `${p?.nombre || ''}${p?.codigo ? ` · ${p.codigo}` : ''}`,
            raw: p
        }));
    }, [paquetesBusqueda]);

    const total = useMemo(() => {
        const totalProductos = items.reduce((acc, it) => {
            const precio = Number(it?.precio || 0);
            const cantidad = Number(it?.cantidad || 0);
            const base = precio * cantidad;
            return acc + (it.iva ? base * 1.16 : base);
        }, 0);

        const totalPaquetes = paquetesItems.reduce((acc, it) => {
            const precio = Number(it?.precio || 0);
            const cantidad = Number(it?.cantidad || 0);
            const base = precio * cantidad;
            return acc + (it.iva ? base * 1.16 : base);
        }, 0);

        return totalProductos + totalPaquetes;
    }, [items, paquetesItems]);

    const algunFiltro = !!(
        categoriaSel?.value ||
        subcategoriaSel?.value ||
        (codigoTienda || '').trim() ||
        (codigoProveedor || '').trim() ||
        (nombreBusquedaInput || '').trim()
    );

    useEffect(() => {
        dispatch(editarBreadcrumb([
            { activo: false, nombre: 'Ventas', path: `/ventas/` },
            { activo: true, nombre: 'Editar Venta', path: `/ventas/editar/${id}` }
        ]));
    }, [dispatch]);

    useEffect(() => {
        dispatch(limpiarVentaEdicion());
        dispatch(listarMetodosVenta());
        dispatch(cargarCategoriasVenta());

        if (!id) {
            dispatch(setAlert('No se pudo identificar la venta en la URL', 'danger'));
            navigate('/ventas');
            return;
        }

        dispatch(cargarVentaEdicion(id));

        return () => {
            dispatch(limpiarVentaEdicion());
            dispatch(limpiarProductosInventarioVenta());
            dispatch(limpiarSubcategoriasVenta());
            dispatch(limpiarDetalleProductoVenta());
            dispatch(limpiarPaquetes());
        };
    }, [dispatch, id, navigate]);

    useEffect(() => {
        if (!ventaEdicion?._id) return;

        const tipoVal = ventaEdicion?.tipo ?? 0;
        const tipoOpt = TIPO_OPTIONS.find((o) => o.value === tipoVal) || TIPO_OPTIONS[0];
        setTipoSeleccionado(tipoOpt);

        const cId = ventaEdicion?.cliente?._id || null;

        if (cId) {
            const raw = ventaEdicion.cliente;
            const opt = {
                value: raw._id,
                label: `${raw?.nombre || ''}${raw?.telefono ? ` (${raw.telefono})` : ''}`,
                raw
            };
            setClientesEncontrados([raw]);
            setClienteSeleccionado(opt);
            setClienteInput('');
        } else {
            setClientesEncontrados([]);
            setClienteSeleccionado(null);
            setClienteInput('');
        }

        const mId = ventaEdicion?.metodo?._id || null;
        const mNombre = ventaEdicion?.metodo?.nombre || '';
        if (mId && tipoVal !== 1) {
            setMetodoSeleccionado({ value: mId, label: mNombre });
        } else {
            setMetodoSeleccionado(null);
        }

        const productos = Array.isArray(ventaEdicion?.productos) ? ventaEdicion.productos : [];
        const seedsRaw = productos.map((p) => {
            const productoId = p?._id || null;

            const mov = p?.movimiento || {};
            const areaId = mov?.area?._id || p?.area?._id || p?.area || null;
            const organizadorId = mov?.organizador?._id || p?.organizador?._id || p?.organizador || null;
            const ubicacionId = mov?.ubicacion?._id || p?.ubicacion?._id || p?.ubicacion || null;

            const unidades = Array.isArray(p?.unidades) ? p.unidades : [];
            const unidadId = p?.unidad?._id || p?.unidad || null;
            const unidadNombre = p?.unidad?.nombre || null;

            const conversion = Number(p?.conversion || 1) || 1;
            const precio = Number(p?.precio || 0);
            const precioBase = Number((precio * conversion).toFixed(6));
            const cantidad = Number(p?.cantidad || 0);

            const inventarioBaseRaw = p?.inventario;
            const inventarioBase = Number.isFinite(Number(inventarioBaseRaw)) ? Number(inventarioBaseRaw) : null;

            const sinInventario = tipoVal === 1 ? false : !areaId;

            const ubicacionLabel = buildUbicacionLabel(mov?.area ? mov : p);

            return {
                key: buildRowKeyFromIds(productoId, areaId, organizadorId, ubicacionId),
                productoId,
                productoNombre: p?.nombre || '',
                codigoTienda: p?.codigo_tienda || '',
                precios: Array.isArray(p?.precios) ? p.precios : [],
                areaId,
                organizadorId,
                ubicacionId,
                ubicacionLabel: ubicacionLabel || null,
                inventarioBase,
                sinInventario,
                unidades,
                unidadId,
                unidadNombre,
                conversion,
                precioBase,
                precio,
                cantidad,
                originalCantidad: cantidad,
                devoluciones: [],
                iva: !!p?.iva
            };
        });

        const seedsMergeMap = new Map();
        seedsRaw.forEach((seed) => {
            if (seedsMergeMap.has(seed.key)) {
                const prev = seedsMergeMap.get(seed.key);
                seedsMergeMap.set(seed.key, {
                    ...prev,
                    cantidad: prev.cantidad + seed.cantidad,
                    originalCantidad: prev.originalCantidad + seed.originalCantidad
                });
            } else {
                seedsMergeMap.set(seed.key, seed);
            }
        });
        const seeds = Array.from(seedsMergeMap.values());

        setItems(seeds);

        const paquetesVenta = Array.isArray(ventaEdicion?.paquetes) ? ventaEdicion.paquetes : [];
        const paqueteSeeds = paquetesVenta.map((vp) => {
            const cantidad = Number(vp?.cantidad || 0);
            const componentes = (Array.isArray(vp?.componentes) ? vp.componentes : []).map((c) => ({
                productoId: c?._id || null,
                productoNombre: c?.nombre || '',
                unidadNombre: c?.unidad?.nombre || '',
                cantidadPorPaquete: Number(c?.cantidad || 0),
                conversion: Number(c?.conversion || 1) || 1,
                areaId: c?.movimiento?.area?._id || null,
                organizadorId: c?.movimiento?.organizador?._id || null,
                ubicacionId: c?.movimiento?.ubicacion?._id || null,
                ubicacionLabel: buildUbicacionLabel(c?.movimiento)
            }));

            return {
                key: `${vp?._id || 'vp'}-${Date.now()}-${Math.random().toString(36).slice(2, 6)}`,
                ventaPaqueteId: vp?._id || null,
                paqueteId: vp?.paquete?._id || null,
                paqueteNombre: vp?.paquete?.nombre || '',
                paqueteCodigo: vp?.paquete?.codigo || '',
                cantidad,
                originalCantidad: cantidad,
                precio: Number(vp?.precio || 0),
                iva: !!vp?.iva,
                devoluciones: [],
                componentes
            };
        });

        setPaquetesItems(paqueteSeeds);

        const enrich = async () => {
            const enriched = await Promise.all(
                seeds.map(async (it) => {
                    if (it.sinInventario) return it;

                    const needsArea = !it.areaId;
                    const needsUnits = !Array.isArray(it.unidades) || it.unidades.length === 0;
                    const needsInventario = it.inventarioBase === null;
                    const needsUbicacion = !it.ubicacionLabel;

                    if (!needsArea && !needsUnits && !needsInventario && !needsUbicacion) {
                        return it;
                    }

                    const codigo = (it.codigoTienda || '').trim();
                    const nombre = (it.productoNombre || '').trim();

                    if (!codigo && !nombre) {
                        return it;
                    }

                    const payload = {
                        codigo: codigo ? codigo : null,
                        codigo_proveedor: null,
                        nombre: codigo ? null : (nombre ? nombre : null)
                    };

                    const productosResp = await dispatch(listarProductosVenta(payload));
                    const arr = Array.isArray(productosResp) ? productosResp : [];

                    if (arr.length === 0) {
                        return it;
                    }

                    let picked = null;

                    if (it.areaId) {
                        picked = arr.find((p) => {
                            const a = p?.area?._id || null;
                            const o = p?.organizador?._id || null;
                            const u = p?.ubicacion?._id || null;

                            const oa = it.organizadorId || null;
                            const ou = it.ubicacionId || null;

                            if (a !== it.areaId) return false;
                            if ((o || null) !== (oa || null)) return false;
                            if ((u || null) !== (ou || null)) return false;
                            return true;
                        }) || null;
                    }

                    if (!picked) {
                        picked = arr.length === 1 ? arr[0] : arr[0];
                    }

                    if (!picked) {
                        return it;
                    }

                    const unidades = Array.isArray(picked?.unidades) ? picked.unidades : [];
                    const inventarioBase = Number.isFinite(Number(picked?.inventario)) ? Number(picked.inventario) : null;

                    let unidadId = it.unidadId || null;
                    let unidadNombre = it.unidadNombre || null;

                    let found = null;
                    if (unidadId && unidades.length > 0) {
                        found = unidades.find((u) => u?.unidad?._id === unidadId) || null;
                    }

                    if (!found && unidades.length > 0) {
                        found = unidades[0];
                        unidadId = found?.unidad?._id || null;
                        unidadNombre = found?.unidad?.nombre || null;
                    }

                    const conversion = Number(found?.cantidad || it.conversion || 1) || 1;

                    const precio = Number(it.precio || 0);
                    const precioBase = Number((precio * conversion).toFixed(6));

                    return {
                        ...it,
                        key: buildRowKey(picked),
                        areaId: picked?.area?._id || it.areaId,
                        organizadorId: picked?.organizador?._id || null,
                        ubicacionId: picked?.ubicacion?._id || null,
                        ubicacionLabel: buildUbicacionLabel(picked),
                        precios: Array.isArray(picked?.precios) ? picked.precios : it.precios,
                        inventarioBase,
                        unidades,
                        unidadId,
                        unidadNombre,
                        conversion,
                        precioBase,
                        precio
                    };
                })
            );

            setItems(enriched.filter((it) => !!it.areaId || it.sinInventario));
        };

        const enrichCotizacion = async () => {
            const enriched = await Promise.all(
                seeds.map(async (it) => {
                    if (!it.productoId) return it;

                    const detalle = await dispatch(cargarDetalleProductoVenta(it.productoId));
                    if (!detalle) return it;

                    const inventarios = Array.isArray(detalle.inventarios) ? detalle.inventarios : [];
                    const stockTotal = inventarios.reduce((acc, inv) => acc + Number(inv?.cantidad || 0), 0);

                    const unidadesDetalle = Array.isArray(detalle.unidades) ? detalle.unidades : [];

                    let unidadId = it.unidadId || null;
                    let unidadNombre = it.unidadNombre || null;
                    let conversion = Number(it.conversion || 1) || 1;

                    if (unidadesDetalle.length > 0) {
                        let found = unidadId
                            ? unidadesDetalle.find((u) => u?.unidad?._id === unidadId) || null
                            : null;

                        if (!found) {
                            found = unidadesDetalle[0];
                            unidadId = found?.unidad?._id || null;
                            unidadNombre = found?.unidad?.nombre || null;
                        }

                        conversion = Number(found?.cantidad || conversion || 1) || 1;
                    }

                    const precio = Number(it.precio || 0);
                    const precioBase = Number((precio * conversion).toFixed(6));

                    return {
                        ...it,
                        inventarioBase: stockTotal,
                        sinInventario: stockTotal <= 0,
                        unidades: unidadesDetalle.length > 0 ? unidadesDetalle : it.unidades,
                        unidadId,
                        unidadNombre,
                        conversion,
                        precioBase,
                        precio
                    };
                })
            );

            setItems(enriched.filter((it) => !!it.productoId));
        };

        const iso = ventaEdicion?.fecha || null;
        setFechaVenta(iso ? new Date(iso) : new Date());
        setMoneda(Number(ventaEdicion?.moneda) === 1 ? 1 : 0);
        setTipoCambioUsd(ventaEdicion?.tipo_cambio ? String(ventaEdicion.tipo_cambio) : '1');
        tcRef.current = ventaEdicion?.tipo_cambio ? Number(ventaEdicion.tipo_cambio) : 1;

        if (tipoVal === 1) {
            enrichCotizacion();
        } else {
            enrich();
        }
    }, [ventaEdicion, dispatch]);

    useEffect(() => {
        if (!metodosOptions.length) return;
        if (esCotizacion) return;

        /* Solo precarga método/cobro inmediato una vez por venta cargada; si el usuario los
           modifica manualmente después no deben volver a sobrescribirse. */
        const ventaId = ventaEdicion?._id || null;
        if (!ventaId || metodoPrefillRef.current === ventaId) return;

        const ventaMetodoId = ventaEdicion?.metodo?._id || null;
        if (ventaMetodoId) {
            const found = metodosOptions.find((m) => m.value === ventaMetodoId) || null;
            if (found) {
                setMetodoSeleccionado(found);
            }
        }

        setCobroInmediato(!!ventaEdicion?.cobro_inmediato);

        metodoPrefillRef.current = ventaId;
    }, [metodosOptions, ventaEdicion, esCotizacion]);

    useEffect(() => {
        if (disabledAll) {
            setClientesEncontrados([]);
            setLoadingClientes(false);
            return;
        }

        const busqueda = (clienteInput || '').trim();

        if (!busqueda) {
            setClientesEncontrados([]);
            setLoadingClientes(false);
            return;
        }

        if (clientTimerRef.current) {
            clearTimeout(clientTimerRef.current);
        }

        setLoadingClientes(true);

        clientTimerRef.current = setTimeout(async () => {
            const res = await dispatch(buscarClientesVenta(busqueda));
            const arr = Array.isArray(res) ? res : [];
            setClientesEncontrados(arr);
            setLoadingClientes(false);
        }, 350);

        return () => {
            if (clientTimerRef.current) {
                clearTimeout(clientTimerRef.current);
            }
        };
    }, [clienteInput, dispatch, disabledAll]);

    useEffect(() => {
        if (disabledAll) return;

        const idCat = categoriaSel?.value || null;
        const idSub = subcategoriaSel?.value || null;
        const ct = (codigoTienda || '').trim();
        const cp = (codigoProveedor || '').trim();
        const n = (nombreBusquedaInput || '').trim();

        const hayFiltro = !!(idCat || idSub || ct || cp || n);

        if (!hayFiltro) {
            dispatch(limpiarProductosInventarioVenta());
            setBuscandoProductos(false);
            return;
        }

        if (productTimerRef.current) {
            clearTimeout(productTimerRef.current);
        }

        setBuscandoProductos(true);

        productTimerRef.current = setTimeout(async () => {
            await dispatch(buscarProductosInventarioVenta({
                id_categoria: idCat,
                id_subcategoria: idSub,
                nombre: n ? n : null,
                codigo_tienda: ct ? ct : null,
                codigo_proveedor: cp ? cp : null
            }));
            setBuscandoProductos(false);
        }, 450);

        return () => {
            if (productTimerRef.current) {
                clearTimeout(productTimerRef.current);
            }
        };
    }, [categoriaSel, subcategoriaSel, codigoTienda, codigoProveedor, nombreBusquedaInput, disabledAll, dispatch]);

    useEffect(() => {
        if (disabledAll) return;

        const q = (busquedaPaquete || '').trim();

        if (!q) {
            dispatch(limpiarPaquetes());
            setBuscandoPaquetes(false);
            return;
        }

        if (paqueteTimerRef.current) {
            clearTimeout(paqueteTimerRef.current);
        }

        setBuscandoPaquetes(true);

        paqueteTimerRef.current = setTimeout(async () => {
            await dispatch(buscarPaquetes({ busqueda: q }));
            setBuscandoPaquetes(false);
        }, 450);

        return () => {
            if (paqueteTimerRef.current) {
                clearTimeout(paqueteTimerRef.current);
            }
        };
    }, [busquedaPaquete, disabledAll, dispatch]);

    const onSelectCliente = (opt) => {
        if (!opt) {
            setClienteSeleccionado(null);
            return;
        }

        setClienteSeleccionado(opt);
        setClienteInput('');
    };

    const guardarNuevoCliente = async (data) => {
        setSavingCliente(true);
        const cliente = await dispatch(crearClienteVenta(data));
        setSavingCliente(false);

        if (!cliente?._id) {
            return;
        }

        const opt = {
            value: cliente._id,
            label: `${cliente?.nombre || ''}${cliente?.telefono ? ` (${cliente.telefono})` : ''}`,
            raw: cliente
        };

        setClientesEncontrados([cliente]);
        setClienteSeleccionado(opt);
        setClienteInput('');
        setShowNuevoCliente(false);
    };

    const onChangeCategoria = (opt) => {
        setCategoriaSel(opt || null);
        setSubcategoriaSel(null);

        if (opt?.value) {
            dispatch(cargarSubcategoriasVenta(opt.value));
        } else {
            dispatch(limpiarSubcategoriasVenta());
        }
    };

    const construirFila = (detalle, sel, precioBase, proveedoresNorm, precioEnMonedaActiva) => {
        const unidades = Array.isArray(detalle?.unidades) ? detalle.unidades : [];
        const unidadDefault = unidades.length > 0 ? unidades[0] : null;
        const unidadId = unidadDefault?.unidad?._id || null;
        const unidadNombre = unidadDefault?.unidad?.nombre || null;
        const conversion = Number(unidadDefault?.cantidad || 1) || 1;
        /* precioBase llega en MXN cuando viene del catálogo (precio de proveedor) y se convierte a la
           moneda activa; si ya se capturó directamente en esa moneda (precio libre, sin inventario),
           se usa tal cual. */
        const precioBaseConvertido = (Number(moneda) === 1 && !precioEnMonedaActiva)
            ? (Number(precioBase || 0) / getTc())
            : Number(precioBase || 0);
        const precio = Number((precioBaseConvertido / conversion).toFixed(3));

        return {
            key: buildRowKeyFromIds(detalle?._id, sel.areaId, sel.organizadorId, sel.ubicacionId),
            productoId: detalle?._id || null,
            productoNombre: detalle?.nombre || '',
            codigoTienda: detalle?.codigo_tienda || '',
            precios: Array.isArray(proveedoresNorm) ? proveedoresNorm : [],
            areaId: sel.areaId,
            organizadorId: sel.organizadorId,
            ubicacionId: sel.ubicacionId,
            ubicacionLabel: sel.ubicacionLabel,
            inventarioBase: Number(sel.inventarioBase || 0),
            sinInventario: !!sel.sinInventario,
            unidades,
            unidadId,
            unidadNombre,
            conversion,
            precioBase: precioBaseConvertido,
            precio,
            cantidad: Number(sel.cantidad || 0),
            originalCantidad: 0,
            iva: false
        };
    };

    const onSelectProducto = async (opt) => {
        if (disabledAll) return;
        if (!opt?.raw?._id) return;

        const detalle = await dispatch(cargarDetalleProductoVenta(opt.raw._id));
        if (!detalle) return;

        const inventarios = Array.isArray(detalle.inventarios) ? detalle.inventarios : [];

        if (!esCotizacion && inventarios.length === 0) {
            dispatch(setAlert('El producto no tiene existencia disponible', 'danger'));
            return;
        }

        setDetalleActual(detalle);
        setShowUbicaciones(true);
    };

    const onConfirmUbicaciones = ({ precioBase, precioEnMonedaActiva, proveedoresNorm, selecciones }) => {
        setShowUbicaciones(false);

        const detalle = detalleActual;
        if (!detalle) return;

        const seleccionadas = Array.isArray(selecciones) ? selecciones.filter((s) => Number(s?.cantidad || 0) > 0) : [];

        if (seleccionadas.length === 0) {
            setDetalleActual(null);
            return;
        }

        setItems((prev) => {
            const copy = [...prev];
            seleccionadas.forEach((sel) => {
                const fila = construirFila(detalle, sel, precioBase, proveedoresNorm, precioEnMonedaActiva);
                const idx = copy.findIndex((x) => x.key === fila.key);
                if (idx >= 0) {
                    copy[idx] = {
                        ...copy[idx],
                        cantidad: Number(copy[idx].cantidad || 0) + fila.cantidad
                    };
                } else {
                    copy.push(fila);
                }
            });
            return copy;
        });

        setDetalleActual(null);
        dispatch(setAlert('Producto agregado', 'success'));
    };

    const cerrarUbicaciones = () => {
        setShowUbicaciones(false);
        setDetalleActual(null);
    };

    const eliminarItem = (key) => {
        setItems((prev) => prev.filter((x) => x.key !== key));
    };

    const abrirDevolver = (it) => {
        setDevolverContexto(it);
        setShowDevolverModal(true);
    };

    const cerrarDevolver = () => {
        setShowDevolverModal(false);
        setDevolverContexto(null);
    };

    const confirmarDevolucion = (destinos) => {
        if (!devolverContexto || !Array.isArray(destinos) || destinos.length === 0) return;

        const totalDevuelto = destinos.reduce((acc, d) => acc + Number(d?.cantidad || 0), 0);

        setItems((prev) => prev.map((x) => {
            if (x.key !== devolverContexto.key) return x;
            return {
                ...x,
                cantidad: Number((Number(x.cantidad || 0) - totalDevuelto).toFixed(6)),
                devoluciones: [...(Array.isArray(x.devoluciones) ? x.devoluciones : []), ...destinos]
            };
        }));

        cerrarDevolver();
    };

    const deshacerDevolucion = (key, idx) => {
        setItems((prev) => prev.map((x) => {
            if (x.key !== key) return x;

            const dev = Array.isArray(x.devoluciones) ? x.devoluciones : [];
            const removida = dev[idx];
            if (!removida) return x;

            return {
                ...x,
                cantidad: Number((Number(x.cantidad || 0) + Number(removida.cantidad || 0)).toFixed(6)),
                devoluciones: dev.filter((_, i) => i !== idx)
            };
        }));
    };

    const onSelectPaquete = (opt) => {
        if (disabledAll) return;
        if (!opt?.raw?._id) return;

        setPaqueteActual(opt.raw);
        setShowSeleccionPaquete(true);
    };

    const onConfirmPaquete = (data) => {
        setShowSeleccionPaquete(false);
        setPaqueteActual(null);

        setPaquetesItems((prev) => ([
            ...prev,
            {
                key: `${data.paqueteId}-${Date.now()}-${Math.random().toString(36).slice(2, 6)}`,
                ventaPaqueteId: null,
                originalCantidad: 0,
                devoluciones: [],
                ...data
            }
        ]));

        dispatch(setAlert('Paquete agregado', 'success'));
    };

    const cerrarSeleccionPaquete = () => {
        setShowSeleccionPaquete(false);
        setPaqueteActual(null);
    };

    const togglePaqueteExpandido = (key) => {
        setPaquetesExpandidos((prev) => ({ ...prev, [key]: !prev[key] }));
    };

    const eliminarPaqueteItem = (key) => {
        setPaquetesItems((prev) => prev.filter((x) => x.key !== key));
    };

    const setPaqueteItemField = (key, field, value) => {
        setPaquetesItems((prev) => prev.map((x) => (x.key === key ? { ...x, [field]: value } : x)));
    };

    const abrirDevolverPaquete = (it) => {
        setDevolverPaqueteContexto(it);
        setShowDevolverPaqueteModal(true);
    };

    const cerrarDevolverPaquete = () => {
        setShowDevolverPaqueteModal(false);
        setDevolverPaqueteContexto(null);
    };

    const confirmarDevolucionPaquete = (destinos) => {
        if (!devolverPaqueteContexto || !Array.isArray(destinos) || destinos.length === 0) return;

        const totalDevuelto = destinos.reduce((acc, d) => acc + Number(d?.cantidad || 0), 0);

        setPaquetesItems((prev) => prev.map((x) => {
            if (x.key !== devolverPaqueteContexto.key) return x;
            return {
                ...x,
                cantidad: Number((Number(x.cantidad || 0) - totalDevuelto).toFixed(6)),
                devoluciones: [...(Array.isArray(x.devoluciones) ? x.devoluciones : []), ...destinos]
            };
        }));

        cerrarDevolverPaquete();
    };

    const deshacerDevolucionPaquete = (key, idx) => {
        setPaquetesItems((prev) => prev.map((x) => {
            if (x.key !== key) return x;

            const dev = Array.isArray(x.devoluciones) ? x.devoluciones : [];
            const removida = dev[idx];
            if (!removida) return x;

            return {
                ...x,
                cantidad: Number((Number(x.cantidad || 0) + Number(removida.cantidad || 0)).toFixed(6)),
                devoluciones: dev.filter((_, i) => i !== idx)
            };
        }));
    };

    const setItemField = (key, field, value) => {
        setItems((prev) => {
            const target = prev.find((x) => x.key === key);
            const productoId = target?.productoId || null;
            return prev.map((x) => {
                if (x.key === key) return { ...x, [field]: value };
                if (field === 'iva' && productoId && x.productoId === productoId) {
                    return { ...x, iva: value };
                }
                return x;
            });
        });
    };

    const onChangeUnidad = (key, unidadOpt) => {
        const unidadId = unidadOpt?.value || null;
        const unidadNombre = unidadOpt?.label || null;

        setItems((prev) =>
            prev.map((x) => {
                if (x.key !== key) return x;

                const found = (Array.isArray(x.unidades) ? x.unidades : []).find((u) => u?.unidad?._id === unidadId);
                const conversion = Number(found?.cantidad || 1);

                return {
                    ...x,
                    unidadId,
                    unidadNombre,
                    conversion,
                    precio: Number(((Number(x.precioBase || 0)) / (Number(conversion || 1) || 1)).toFixed(3))
                };
            })
        );
    };

    const abrirPreciosProveedor = (it) => {
        setPreciosContexto({
            productoNombre: it?.productoNombre || '',
            codigoTienda: it?.codigoTienda || '',
            precios: Array.isArray(it?.precios) ? it.precios : []
        });
        setShowPreciosProveedor(true);
    };

    const cerrarPreciosProveedor = () => {
        setShowPreciosProveedor(false);
        setPreciosContexto({
            productoNombre: '',
            codigoTienda: '',
            precios: []
        });
    };

    const guardarConItems = async (itemsList) => {
        const totalCalculado = itemsList.reduce((acc, it) => {
            const precio = Number(it?.precio || 0);
            const cantidad = Number(it?.cantidad || 0);
            const base = precio * cantidad;
            return acc + (it.iva ? base * 1.16 : base);
        }, 0);

        const productos = itemsList.map((it) => ({
            producto: it.productoId,
            unidad: it.unidadId || null,
            cantidad: Number(it.cantidad || 0),
            precio: Number(it.precio || 0),
            conversion: Number(it.conversion || 1),
            area: it.areaId,
            organizador: it.organizadorId || null,
            ubicacion: it.ubicacionId || null,
            iva: it.iva || false,
            devoluciones: (Array.isArray(it.devoluciones) ? it.devoluciones : []).map((d) => ({
                cantidad: Number(d?.cantidad || 0),
                area: d?.area?._id || null,
                organizador: d?.organizador?._id || null,
                ubicacion: d?.ubicacion?._id || null
            }))
        }));

        const paquetes = paquetesItems.map((it) => {
            const cantidadPaquetes = Number(it.cantidad || 0);
            const componentesList = Array.isArray(it.componentes) ? it.componentes : [];

            return {
                paquete: it.paqueteId,
                cantidad: cantidadPaquetes,
                precio: Number(it.precio || 0),
                iva: it.iva || false,
                componentes: componentesList.map((c) => {
                    const conversion = Number(c.conversion || 1) || 1;
                    const cantidadComponente = (Number(c.cantidadPorPaquete || 0) * cantidadPaquetes) / conversion;
                    return {
                        producto: c.productoId,
                        cantidad: cantidadComponente,
                        area: c.areaId || null,
                        organizador: c.organizadorId || null,
                        ubicacion: c.ubicacionId || null
                    };
                }),
                /* El origen (from_*) es la ubicación donde ya está asignado cada componente en esta
                   línea de venta — el backend lo necesita para distinguir de cuál origen sale cada
                   devolución cuando un mismo producto pueda tener más de un origen. */
                devoluciones: (Array.isArray(it.devoluciones) ? it.devoluciones : []).map((d) => ({
                    cantidad: Number(d?.cantidad || 0),
                    componentes: (Array.isArray(d?.componentes) ? d.componentes : []).map((dc) => {
                        const origen = componentesList.find((c) => c.productoId === dc?.productoId);
                        return {
                            producto: dc?.productoId || null,
                            from_area: origen?.areaId || null,
                            from_organizador: origen?.organizadorId || null,
                            from_ubicacion: origen?.ubicacionId || null,
                            area: dc?.area?._id || null,
                            organizador: dc?.organizador?._id || null,
                            ubicacion: dc?.ubicacion?._id || null
                        };
                    })
                }))
            };
        });

        const totalPaquetesCalculado = paquetesItems.reduce((acc, it) => {
            const precio = Number(it?.precio || 0);
            const cantidad = Number(it?.cantidad || 0);
            const base = precio * cantidad;
            return acc + (it.iva ? base * 1.16 : base);
        }, 0);

        const fecha = fechaVenta ? fechaVenta.toISOString() : null;
        const idCliente = clienteSeleccionado?.value || null;
        const idMetodo = esCotizacion ? null : (metodoSeleccionado?.value || null);

        const venta = await dispatch(editarVenta({
            id,
            id_cliente: idCliente || null,
            id_metodo: idMetodo,
            tipo: tipoSeleccionado?.value ?? 0,
            cobro_inmediato: esCotizacion ? null : esCobradaInmediato,
            moneda: Number(moneda) === 1 ? 1 : 0,
            tipo_cambio: Number(moneda) === 1 ? getTc() : 1,
            fecha,
            total: totalCalculado + totalPaquetesCalculado,
            productos,
            paquetes
        }));

        if (!venta?._id) return;
        setVentaEditadaLocal(venta);
    };

    const abrirConvertir = async () => {
        if (!items.length && !paquetesItems.length) return;

        setCargandoUbicacionesConvertir(true);

        const conUbicaciones = await Promise.all(items.map(async (it) => {
            if (it.sinInventario) {
                return { ...it, ubicacionesDisponibles: [] };
            }

            const detalle = await dispatch(cargarDetalleProductoVenta(it.productoId));
            const inventarios = Array.isArray(detalle?.inventarios) ? detalle.inventarios : [];

            const ubicacionesDisponibles = inventarios
                .map((inv) => ({
                    areaId: inv?.area?._id || null,
                    organizadorId: inv?.organizador?._id || null,
                    ubicacionId: inv?.ubicacion?._id || null,
                    label: buildUbicacionLabel(inv) || 'Sin ubicación',
                    disponible: Number(inv?.cantidad || 0) * Number(it.conversion || 1)
                }))
                .filter((u) => u.disponible > 0);

            return { ...it, ubicacionesDisponibles };
        }));

        /* Para los componentes de los paquetes, el disponible se mantiene en unidades base de
           inventario (sin multiplicar por conversión) porque así se expresa "necesaria" al
           compararlas — mismo criterio que SeleccionPaqueteModal. Se cachea por producto para no
           repetir la consulta si el mismo componente aparece en varios paquetes. */
        const cacheInventarioComponentes = {};

        const paquetesConUbicaciones = await Promise.all(paquetesItems.map(async (p) => {
            const componentes = Array.isArray(p.componentes) ? p.componentes : [];

            const componentesConUbicaciones = await Promise.all(componentes.map(async (c) => {
                if (!cacheInventarioComponentes[c.productoId]) {
                    const detalle = await dispatch(cargarDetalleProductoVenta(c.productoId));
                    const inventarios = Array.isArray(detalle?.inventarios) ? detalle.inventarios : [];
                    cacheInventarioComponentes[c.productoId] = inventarios
                        .map((inv) => ({
                            areaId: inv?.area?._id || null,
                            organizadorId: inv?.organizador?._id || null,
                            ubicacionId: inv?.ubicacion?._id || null,
                            label: buildUbicacionLabel(inv) || 'Sin ubicación',
                            disponible: Number(inv?.cantidad || 0)
                        }))
                        .filter((u) => u.disponible > 0);
                }

                return { ...c, ubicacionesDisponibles: cacheInventarioComponentes[c.productoId] };
            }));

            return { ...p, componentes: componentesConUbicaciones };
        }));

        setCargandoUbicacionesConvertir(false);
        setProductosConvertirDetalle(conUbicaciones);
        setPaquetesConvertirDetalle(paquetesConUbicaciones);
        setShowConvertirModal(true);
    };

    const cerrarConvertir = () => {
        setShowConvertirModal(false);
        setProductosConvertirDetalle([]);
        setPaquetesConvertirDetalle([]);
    };

    /* Conversión todo o nada: la cotización siempre existió como un único registro (id) y aquí
       se edita ese mismo registro en el lugar, pasándolo de tipo:1 (cotización) a tipo:0 (venta),
       con inventario real asignado a cada línea. No se crea una venta aparte ni se deja remanente
       en la cotización — o se convierte completa, o no se confirma. */
    const confirmarConvertir = async ({ id_metodo, cobro_inmediato, moneda: monedaConvertir, tipo_cambio: tcConvertir, fecha, lineas, lineasPaquetes }) => {
        const lineasPaquetesArr = Array.isArray(lineasPaquetes) ? lineasPaquetes : [];

        if ((!Array.isArray(lineas) || lineas.length === 0) && lineasPaquetesArr.length === 0) {
            dispatch(setAlert('Agrega al menos un producto o paquete', 'danger'));
            return;
        }

        const idCliente = clienteSeleccionado?.value || null;
        const esCobradaInmediatoConvertir = !idCliente || cobro_inmediato;

        if (!idCliente && !esCobradaInmediatoConvertir) {
            dispatch(setAlert('Una venta a crédito requiere un cliente', 'danger'));
            return;
        }

        if (esCobradaInmediatoConvertir && !id_metodo) {
            dispatch(setAlert('El cobro en el momento requiere un método de pago', 'danger'));
            return;
        }

        setGuardandoConvertir(true);

        const productosVenta = lineas.map(buildProductoPayload);

        const paquetesVenta = lineasPaquetesArr.map((p) => ({
            paquete: p.paqueteId,
            cantidad: Number(p.cantidad || 0),
            precio: Number(p.precio || 0),
            iva: p.iva || false,
            componentes: (Array.isArray(p.componentes) ? p.componentes : []).map((c) => ({
                producto: c.productoId,
                cantidad: Number(c.cantidad || 0),
                area: c.areaId || null,
                organizador: c.organizadorId || null,
                ubicacion: c.ubicacionId || null
            }))
        }));

        const totalProductosVenta = lineas.reduce((acc, it) => {
            const base = Number(it.precio || 0) * Number(it.cantidad || 0);
            return acc + (it.iva ? base * 1.16 : base);
        }, 0);

        const totalPaquetesVenta = lineasPaquetesArr.reduce((acc, it) => {
            const base = Number(it.precio || 0) * Number(it.cantidad || 0);
            return acc + (it.iva ? base * 1.16 : base);
        }, 0);

        const fechaElegida = fecha instanceof Date ? fecha : new Date();

        const ventaConvertida = await dispatch(editarVenta({
            id,
            id_cliente: idCliente,
            id_metodo,
            tipo: 0,
            cobro_inmediato: esCobradaInmediatoConvertir,
            moneda: Number(monedaConvertir) === 1 ? 1 : 0,
            tipo_cambio: Number(monedaConvertir) === 1 ? (Number(tcConvertir) || 1) : 1,
            fecha: fechaElegida.toISOString(),
            total: totalProductosVenta + totalPaquetesVenta,
            productos: productosVenta,
            paquetes: paquetesVenta
        }));

        setGuardandoConvertir(false);

        if (!ventaConvertida?._id) return;

        setShowConvertirModal(false);
        setProductosConvertirDetalle([]);
        setPaquetesConvertirDetalle([]);

        dispatch(setAlert(
            `Cotización convertida en venta${ventaConvertida?.folio ? ` ${ventaConvertida.folio}` : ''} correctamente`,
            'success'
        ));

        setVentaEditadaLocal(ventaConvertida);

        dispatch(limpiarVentaEdicion());
        dispatch(cargarVentaEdicion(id));
    };

    const editarVentaHandler = async () => {
        if (disabledAll) return;

        if (!id) {
            dispatch(setAlert('No se pudo identificar la venta', 'danger'));
            return;
        }

        const idClienteActual = clienteSeleccionado?.value || null;

        if (!esCotizacion && !idClienteActual && !esCobradaInmediato) {
            dispatch(setAlert('Una venta a crédito requiere un cliente', 'danger'));
            return;
        }

        if (!esCotizacion && esCobradaInmediato && !metodoSeleccionado?.value) {
            dispatch(setAlert('El cobro en el momento requiere un método de pago', 'danger'));
            return;
        }

        if (!validarTipoCambioSiUSD()) {
            dispatch(setAlert('Tipo de cambio inválido', 'danger'));
            return;
        }

        if (!items.length && !paquetesItems.length) {
            dispatch(setAlert('Agrega al menos un producto o paquete', 'danger'));
            return;
        }

        const invalid = items.find((it) => {
            const cantidad = Number(it?.cantidad || 0);
            const precio = Number(it?.precio || 0);
            const originalCantidad = Number(it?.originalCantidad || 0);
            const totalDevuelto = (Array.isArray(it?.devoluciones) ? it.devoluciones : [])
                .reduce((acc, d) => acc + Number(d?.cantidad || 0), 0);
            const esProductoOriginalRow = !esCotizacionOriginal && originalCantidad > 0;
            const pisoCantidad = esProductoOriginalRow ? Math.max(0, originalCantidad - totalDevuelto) : 0;

            if (!it?.productoId) return true;
            if (precio < 0) return true;

            if (esProductoOriginalRow) {
                // Si ya se devolvió algo de esta línea, no se permite además agregar cantidad
                // extra en la misma edición (devolver y agregar son mutuamente excluyentes).
                if (totalDevuelto > 0 && cantidad !== pisoCantidad) return true;
                if (cantidad < pisoCantidad) return true;
            } else if (cantidad <= 0) {
                return true;
            }

            if (it?.sinInventario) return false;

            if (!esCotizacionOriginal && !it?.areaId) return true;

            // En cotización se permite exceder el inventario disponible (la conversión a venta
            // valida el inventario por separado en ConvertirVentaModal)
            if (!esCotizacionOriginal) {
                const invBase = it?.inventarioBase;
                const hasInv = Number.isFinite(Number(invBase));
                if (hasInv) {
                    const inventarioMostrado = Number(invBase || 0) * Number(it?.conversion || 1);
                    const maxCantidad = Number(inventarioMostrado) + originalCantidad;
                    if (cantidad > maxCantidad) return true;
                }
            }

            return false;
        });

        if (invalid) {
            dispatch(setAlert('Revisa cantidades, inventario y precios. Hay productos excedidos o inválidos.', 'danger'));
            return;
        }

        const invalidPaquete = paquetesItems.find((it) => {
            const cantidad = Number(it?.cantidad || 0);
            const precio = Number(it?.precio || 0);
            const originalCantidad = Number(it?.originalCantidad || 0);
            const totalDevuelto = (Array.isArray(it?.devoluciones) ? it.devoluciones : [])
                .reduce((acc, d) => acc + Number(d?.cantidad || 0), 0);
            const esPaqueteOriginal = !esCotizacionOriginal && originalCantidad > 0;
            const pisoCantidad = esPaqueteOriginal ? Math.max(0, originalCantidad - totalDevuelto) : 0;

            if (!it?.paqueteId) return true;
            if (precio < 0) return true;

            if (esPaqueteOriginal) {
                if (totalDevuelto > 0 && cantidad !== pisoCantidad) return true;
                if (cantidad < pisoCantidad) return true;
            } else if (cantidad <= 0) {
                return true;
            }

            if (!esCotizacionOriginal) {
                const componentes = Array.isArray(it?.componentes) ? it.componentes : [];
                if (componentes.some((c) => !c?.ubicacionId && !c?.areaId)) return true;
            }

            return false;
        });

        if (invalidPaquete) {
            dispatch(setAlert('Revisa cantidades y ubicaciones de los paquetes. Hay paquetes inválidos.', 'danger'));
            return;
        }

        await guardarConItems(items);
    };

    const folioShown = ventaEditadaLocal?.folio || ventaEdicion?.folio || '';
    const tituloEdicion = esCotizacionOriginal ? 'Editar Cotización' : 'Editar Venta';

    // Layout dinámico de la fila superior según tipo original y estado actual del select
    const colClienteMd = esCotizacionOriginal ? (esCotizacion ? 5 : 4) : 4;
    const colMetodoMd = esCotizacionOriginal ? 2 : 2;

    return (
        <Fragment>
            <div className="d-flex justify-content-between align-items-center mb-3">
                <div>
                    <div className="d-flex align-items-center gap-2">
                        <h3 className="mb-0">{tituloEdicion}</h3>
                        {folioShown ? <Badge bg="primary">Folio: {folioShown}</Badge> : null}
                    </div>
                    <div className="text-muted mt-1" style={{ fontSize: 13 }}>
                        Cliente opcional. Filtra productos y selecciona uno para elegir ubicaciones y cantidades.
                    </div>
                </div>
            </div>

            <Card className="mb-3" style={{ overflow: 'visible' }}>
                <Card.Body style={{ overflow: 'visible' }}>
                    <Row className="g-3 align-items-end">
                        <Col md={1}>
                            <div className="text-muted mb-1" style={{ fontSize: 12 }}>Fecha</div>
                            <DatePicker
                                selected={fechaVenta}
                                onChange={(d) => setFechaVenta(d)}
                                className="form-control"
                                placeholderText="Fecha"
                                dateFormat="dd/MM/yyyy"
                                disabled={disabledAll}
                            />
                        </Col>

                        <Col md={colClienteMd}>
                            <div className="d-flex justify-content-between align-items-center mb-1">
                                <div className="text-muted" style={{ fontSize: 12 }}>Cliente (opcional)</div>
                                {loadingClientes ? <span className="text-muted" style={{ fontSize: 12 }}>Buscando...</span> : null}
                            </div>
                            <Select
                                placeholder="Escribe para buscar..."
                                isClearable
                                isDisabled={disabledAll}
                                isLoading={loadingClientes}
                                value={clienteSeleccionado}
                                inputValue={clienteInput}
                                onInputChange={(val, meta) => {
                                    if (meta.action === 'input-change') {
                                        setClienteInput(val);
                                    }
                                }}
                                onChange={onSelectCliente}
                                options={clienteOptions}
                                menuPortalTarget={menuPortalTarget}
                                menuPosition="fixed"
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 })
                                }}
                                components={{ NoOptionsMessage: NoOptionsClientes }}
                                onAgregarCliente={() => setShowNuevoCliente(true)}
                            />
                        </Col>

                        {esCotizacionOriginal && (
                            <Col md={2}>
                                <div className="text-muted mb-1" style={{ fontSize: 12 }}>Tipo</div>
                                <Select
                                    isDisabled
                                    value={tipoSeleccionado}
                                    options={TIPO_OPTIONS}
                                    menuPortalTarget={menuPortalTarget}
                                    menuPosition="fixed"
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 })
                                    }}
                                    isSearchable={false}
                                />
                            </Col>
                        )}

                        {!esCotizacion && (
                            <Col md={2}>
                                <div className="text-muted mb-1" style={{ fontSize: 12 }}>&nbsp;</div>
                                <Form.Check
                                    type="checkbox"
                                    id="editar-venta-cobro-inmediato"
                                    label="Cobro inmediato"
                                    checked={esCobradaInmediato}
                                    disabled={disabledAll || !clienteSeleccionado?.value}
                                    onChange={(e) => {
                                        const checked = e.target.checked;
                                        setCobroInmediato(checked);
                                        if (!checked) setMetodoSeleccionado(null);
                                    }}
                                />
                            </Col>
                        )}

                        {!esCotizacion && (
                            <Col md={colMetodoMd}>
                                <div className="text-muted mb-1" style={{ fontSize: 12 }}>
                                    Método de pago{esCobradaInmediato ? '' : ' (opcional)'}
                                </div>
                                <Select
                                    placeholder="Selecciona método"
                                    isClearable
                                    isDisabled={disabledAll || !esCobradaInmediato}
                                    value={metodoSeleccionado}
                                    onChange={(opt) => setMetodoSeleccionado(opt || null)}
                                    options={metodosOptions}
                                    menuPortalTarget={menuPortalTarget}
                                    menuPosition="fixed"
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 })
                                    }}
                                    noOptionsMessage={() => 'Sin métodos'}
                                />
                            </Col>
                        )}

                        <Col md={1}>
                            <div className="text-muted mb-1" style={{ fontSize: 12 }}>Moneda</div>
                            <Form.Select
                                value={moneda}
                                disabled={disabledAll}
                                onChange={(e) => onChangeMoneda(e.target.value)}
                            >
                                <option value={0}>MXN</option>
                                <option value={1}>USD</option>
                            </Form.Select>
                        </Col>

                        <Col md={1}>
                            <div className="text-muted mb-1" style={{ fontSize: 12 }}>T. Cambio</div>
                            <Form.Control
                                type="number"
                                min="0"
                                value={Number(moneda) === 1 ? tipoCambioUsd : '1'}
                                onChange={(e) => onChangeTipoCambio(e.target.value)}
                                disabled={disabledAll || Number(moneda) !== 1}
                            />
                        </Col>
                    </Row>

                    {!esCotizacion && !esCobradaInmediato && (
                        <div className="alert alert-warning mt-3 mb-0" style={{ fontSize: 13 }}>
                            Venta a crédito: se sumará al saldo pendiente del cliente en su cuenta.
                        </div>
                    )}
                </Card.Body>
            </Card>

            <Card className="mb-3" style={{ overflow: 'visible' }}>
                <Card.Body style={{ overflow: 'visible' }}>
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <div className="fw-semibold">Buscar productos</div>
                        {buscandoProductos ? <span className="text-muted" style={{ fontSize: 12 }}>Buscando...</span> : null}
                    </div>

                    <Row className="g-3 align-items-end">
                        <Col md={3}>
                            <div className="text-muted mb-1" style={{ fontSize: 12 }}>Categoría</div>
                            <Select
                                placeholder="Categoría"
                                isClearable
                                isDisabled={disabledAll}
                                value={categoriaSel}
                                onChange={onChangeCategoria}
                                options={categoriasOptions}
                                menuPortalTarget={menuPortalTarget}
                                menuPosition="fixed"
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 })
                                }}
                                noOptionsMessage={() => 'Sin categorías'}
                            />
                        </Col>

                        <Col md={3}>
                            <div className="text-muted mb-1" style={{ fontSize: 12 }}>Subcategoría</div>
                            <Select
                                placeholder="Subcategoría"
                                isClearable
                                isDisabled={disabledAll || !categoriaSel?.value}
                                value={subcategoriaSel}
                                onChange={(opt) => setSubcategoriaSel(opt || null)}
                                options={subcategoriasOptions}
                                menuPortalTarget={menuPortalTarget}
                                menuPosition="fixed"
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 })
                                }}
                                noOptionsMessage={() => 'Sin subcategorías'}
                            />
                        </Col>

                        <Col md={3}>
                            <div className="text-muted mb-1" style={{ fontSize: 12 }}>Código tienda</div>
                            <Form.Control
                                type="text"
                                placeholder="Ej. IN018"
                                value={codigoTienda}
                                disabled={disabledAll}
                                onChange={(e) => setCodigoTienda(e.target.value)}
                            />
                        </Col>

                        <Col md={3}>
                            <div className="text-muted mb-1" style={{ fontSize: 12 }}>Código proveedor</div>
                            <Form.Control
                                type="text"
                                placeholder="Ej. TBA-033"
                                value={codigoProveedor}
                                disabled={disabledAll}
                                onChange={(e) => setCodigoProveedor(e.target.value)}
                            />
                        </Col>

                        <Col md={6}>
                            <div className="text-muted mb-1" style={{ fontSize: 12 }}>Nombre</div>
                            <Form.Control
                                type="text"
                                placeholder="Nombre del producto"
                                value={nombreBusquedaInput}
                                disabled={disabledAll}
                                onChange={(e) => setNombreBusquedaInput(e.target.value)}
                            />
                        </Col>

                        <Col md={6}>
                            <div className="text-muted mb-1" style={{ fontSize: 12 }}>Producto</div>
                            <Select
                                placeholder="Selecciona un producto de los resultados..."
                                isDisabled={disabledAll}
                                value={null}
                                onChange={onSelectProducto}
                                options={productosOptions}
                                isLoading={buscandoProductos}
                                menuPortalTarget={menuPortalTarget}
                                menuPosition="fixed"
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 })
                                }}
                                noOptionsMessage={() =>
                                    buscandoProductos
                                        ? 'Buscando...'
                                        : (algunFiltro ? 'Sin resultados' : 'Aplica un filtro para buscar')
                                }
                            />
                        </Col>
                    </Row>
                </Card.Body>
            </Card>

            <Card className="mb-3" style={{ overflow: 'visible' }}>
                <Card.Body style={{ overflow: 'visible' }}>
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <div className="fw-semibold">Productos</div>
                        <div className="d-flex align-items-center gap-2">
                            <div className="text-muted">Total</div>
                            <div className="fs-5 fw-bold">{prefMoneda} {formatMoney(total)}</div>
                        </div>
                    </div>

                    {items.length === 0 ? (
                        <div className="text-muted" style={{ padding: '18px 0' }}>
                            Aún no hay productos. Busca uno y agrégalo.
                        </div>
                    ) : (
                        <div className="table-responsive" style={{ overflow: 'visible' }}>
                            <Table bordered hover className="mb-0" style={{ overflow: 'visible' }}>
                                <thead>
                                    <tr>
                                        <th style={{ width: 110 }}>Código INRA</th>
                                        <th>Producto</th>
                                        <th>Ubicación</th>
                                        <th style={{ width: 190 }}>$ Venta</th>
                                        <th style={{ width: 70 }} className="text-center">IVA</th>
                                        <th style={{ width: 150 }}>Inventario</th>
                                        <th style={{ width: 150 }}>Cantidad</th>
                                        <th style={{ width: 240 }}>Unidad</th>
                                        <th style={{ width: 150 }}>Subtotal</th>
                                        <th style={{ width: 130 }}>Opciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {items.map((it) => {
                                        const unidadesOptions = (Array.isArray(it.unidades) ? it.unidades : []).map((u) => ({
                                            value: u?.unidad?._id || null,
                                            label: u?.unidad?.nombre || ''
                                        }));

                                        const unidadValue = it.unidadId
                                            ? { value: it.unidadId, label: it.unidadNombre || '' }
                                            : null;

                                        const invBase = it?.inventarioBase;
                                        const hasInv = Number.isFinite(Number(invBase));
                                        const inventarioMostrado = hasInv ? (Number(invBase || 0) * Number(it.conversion || 1)) : null;

                                        const cantidad = Number(it.cantidad || 0);
                                        const originalCantidad = Number(it.originalCantidad || 0);

                                        const esProductoOriginal = !esCotizacionOriginal && originalCantidad > 0;

                                        const devoluciones = Array.isArray(it.devoluciones) ? it.devoluciones : [];
                                        const totalDevuelto = devoluciones.reduce((acc, d) => acc + Number(d?.cantidad || 0), 0);
                                        const pisoCantidad = esProductoOriginal ? Math.max(0, originalCantidad - totalDevuelto) : 0;

                                        const maxCantidad = hasInv
                                            ? Number(inventarioMostrado || 0) + originalCantidad
                                            : null;
                                        const isOver = (it.sinInventario || esCotizacionOriginal)
                                            ? false
                                            : (hasInv ? (cantidad > maxCantidad) : false);
                                        const isUnder = esProductoOriginal && cantidad < pisoCantidad;

                                        const subtotal = Number(it.precio || 0) * cantidad * (it.iva ? 1.16 : 1);

                                        return (
                                            <tr key={it.key} className={(isOver || isUnder) ? 'table-danger' : ''}>
                                                <td>
                                                    <div className="fw-semibold">{it.codigoTienda || '-'}</div>
                                                </td>
                                                <td>
                                                    <div className="fw-semibold">{it.productoNombre}</div>
                                                </td>
                                                <td>{it.ubicacionLabel || (it.sinInventario ? 'Sin existencia' : '-')}</td>
                                                <td>
                                                    <CurrencyInput
                                                        value={it.precio}
                                                        decimalsLimit={3}
                                                        allowNegativeValue={false}
                                                        placeholder={`${prefMoneda} Venta`}
                                                        className="form-control"
                                                        prefix={`${prefMoneda} `}
                                                        groupSeparator=","
                                                        decimalSeparator="."
                                                        disabled={disabledAll}
                                                        onValueChange={(value) => {
                                                            const raw = value === undefined || value === null ? '' : value;
                                                            const v = raw === '' ? 0 : Number(raw);
                                                            setItems((prev) =>
                                                                prev.map((x) => {
                                                                    if (x.key !== it.key && x.productoId !== it.productoId) return x;
                                                                    const conv = Number(x.conversion || 1) || 1;
                                                                    return {
                                                                        ...x,
                                                                        precio: raw,
                                                                        precioBase: Number((v * conv).toFixed(6))
                                                                    };
                                                                })
                                                            );
                                                        }}
                                                    />
                                                </td>
                                                <td className="text-center align-middle">
                                                    <Form.Check
                                                        type="checkbox"
                                                        checked={!!it.iva}
                                                        disabled={disabledAll}
                                                        onChange={() => setItemField(it.key, 'iva', !it.iva)}
                                                    />
                                                </td>
                                                <td>
                                                    <div className="fw-semibold">
                                                        {!it.sinInventario && hasInv ? formatNumber(inventarioMostrado) : '-'}
                                                    </div>
                                                </td>
                                                <td>
                                                    <Form.Control
                                                        type="number"
                                                        value={it.cantidad}
                                                        min={esProductoOriginal ? pisoCantidad : 0}
                                                        placeholder="Cantidad"
                                                        disabled={disabledAll || totalDevuelto > 0}
                                                        className={(isOver || isUnder) ? 'is-invalid' : ''}
                                                        onChange={(e) => {
                                                            const v = e.target.value === '' ? 0 : Number(e.target.value);
                                                            setItemField(it.key, 'cantidad', v);
                                                        }}
                                                    />
                                                    {isOver ? (
                                                        <div className="invalid-feedback d-block">
                                                            Excede inventario disponible
                                                        </div>
                                                    ) : null}
                                                    {isUnder ? (
                                                        <div className="invalid-feedback d-block">
                                                            No se puede reducir (usa devolución)
                                                        </div>
                                                    ) : null}
                                                    {devoluciones.length > 0 && (
                                                        <div className="mt-1">
                                                            {devoluciones.map((d, idx) => (
                                                                <div key={idx} className="d-flex align-items-center justify-content-between text-muted" style={{ fontSize: 11 }}>
                                                                    <span>
                                                                        Devuelto {formatNumber(d?.cantidad)} → {[d?.area?.nombre, d?.organizador?.nombre, d?.ubicacion?.nombre].filter(Boolean).join(' / ') || 'Sin ubicación'}
                                                                    </span>
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-sm btn-link text-danger p-0 ms-1"
                                                                        title="Deshacer devolución"
                                                                        disabled={disabledAll}
                                                                        onClick={() => deshacerDevolucion(it.key, idx)}
                                                                    >
                                                                        <i className="fas fa-times" />
                                                                    </button>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    )}
                                                </td>
                                                <td style={{ overflow: 'visible' }}>
                                                    {unidadesOptions.length > 0 ? (
                                                        <Select
                                                            placeholder="Unidad"
                                                            isDisabled={disabledAll}
                                                            value={unidadValue}
                                                            onChange={(opt) => onChangeUnidad(it.key, opt)}
                                                            options={unidadesOptions}
                                                            menuPortalTarget={menuPortalTarget}
                                                            menuPosition="fixed"
                                                            styles={{
                                                                menuPortal: (base) => ({ ...base, zIndex: 9999 })
                                                            }}
                                                        />
                                                    ) : (
                                                        <Form.Control
                                                            type="text"
                                                            value={it.unidadNombre || 'N/A'}
                                                            disabled
                                                        />
                                                    )}
                                                </td>
                                                <td className="align-middle">
                                                    <div className="fw-semibold">{prefMoneda} {formatMoney(subtotal)}</div>
                                                </td>
                                                <td className="text-center">
                                                    <div className="d-flex justify-content-center gap-2">
                                                        <Button
                                                            variant="outline-primary"
                                                            size="sm"
                                                            onClick={() => abrirPreciosProveedor(it)}
                                                            title="Ver precios del proveedor"
                                                            disabled={disabledAll}
                                                        >
                                                            <i className="fas fa-eye" />
                                                        </Button>
                                                        {esProductoOriginal && (
                                                            <Button
                                                                variant="outline-warning"
                                                                size="sm"
                                                                onClick={() => abrirDevolver(it)}
                                                                title={cantidad > originalCantidad
                                                                    ? 'No se puede devolver: ya se agregó cantidad extra a este producto'
                                                                    : 'Devolver producto'}
                                                                disabled={disabledAll || cantidad <= 0 || cantidad > originalCantidad}
                                                            >
                                                                <i className="fas fa-rotate-left" />
                                                            </Button>
                                                        )}
                                                        <Button
                                                            variant="danger"
                                                            size="sm"
                                                            onClick={() => eliminarItem(it.key)}
                                                            title={esProductoOriginal ? 'Usa devolución para retirar este producto' : 'Eliminar'}
                                                            disabled={disabledAll || esProductoOriginal}
                                                        >
                                                            <i className="fas fa-trash" />
                                                        </Button>
                                                    </div>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </Table>
                        </div>
                    )}
                </Card.Body>
            </Card>

            <Card className="mb-3" style={{ overflow: 'visible' }}>
                <Card.Body style={{ overflow: 'visible' }}>
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <div className="fw-semibold">Buscar paquetes</div>
                        {buscandoPaquetes ? <span className="text-muted" style={{ fontSize: 12 }}>Buscando...</span> : null}
                    </div>

                    <Row className="g-3 align-items-end">
                        <Col md={6}>
                            <div className="text-muted mb-1" style={{ fontSize: 12 }}>Nombre o código</div>
                            <Form.Control
                                type="text"
                                placeholder="Nombre o código del paquete"
                                value={busquedaPaquete}
                                disabled={disabledAll}
                                onChange={(e) => setBusquedaPaquete(e.target.value)}
                            />
                        </Col>

                        <Col md={6}>
                            <div className="text-muted mb-1" style={{ fontSize: 12 }}>Paquete</div>
                            <Select
                                placeholder="Selecciona un paquete de los resultados..."
                                isDisabled={disabledAll}
                                value={null}
                                onChange={onSelectPaquete}
                                options={paquetesOptions}
                                isLoading={buscandoPaquetes}
                                menuPortalTarget={menuPortalTarget}
                                menuPosition="fixed"
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 })
                                }}
                                noOptionsMessage={() =>
                                    buscandoPaquetes
                                        ? 'Buscando...'
                                        : ((busquedaPaquete || '').trim() ? 'Sin resultados' : 'Escribe para buscar')
                                }
                            />
                        </Col>
                    </Row>
                </Card.Body>
            </Card>

            <Card className="mb-3" style={{ overflow: 'visible' }}>
                <Card.Body style={{ overflow: 'visible' }}>
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <div className="fw-semibold">Paquetes</div>
                    </div>

                    {paquetesItems.length === 0 ? (
                        <div className="text-muted" style={{ padding: '18px 0' }}>
                            Aún no hay paquetes. Busca uno y agrégalo.
                        </div>
                    ) : (
                        <div className="table-responsive" style={{ overflow: 'visible' }}>
                            <Table bordered hover className="mb-0" style={{ overflow: 'visible' }}>
                                <thead>
                                    <tr>
                                        <th style={{ width: 30 }} />
                                        <th>Paquete</th>
                                        <th style={{ width: 190 }}>$ Venta</th>
                                        <th style={{ width: 70 }} className="text-center">IVA</th>
                                        <th style={{ width: 150 }}>Cantidad</th>
                                        <th style={{ width: 150 }}>Subtotal</th>
                                        <th style={{ width: 110 }}>Opciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {paquetesItems.map((it) => {
                                        const cantidad = Number(it.cantidad || 0);
                                        const originalCantidad = Number(it.originalCantidad || 0);
                                        const esPaqueteOriginal = !esCotizacionOriginal && originalCantidad > 0;
                                        const devoluciones = Array.isArray(it.devoluciones) ? it.devoluciones : [];
                                        const totalDevuelto = devoluciones.reduce((acc, d) => acc + Number(d?.cantidad || 0), 0);
                                        const pisoCantidad = esPaqueteOriginal ? Math.max(0, originalCantidad - totalDevuelto) : 0;
                                        const isUnder = esPaqueteOriginal && cantidad < pisoCantidad;
                                        const subtotal = Number(it.precio || 0) * cantidad * (it.iva ? 1.16 : 1);
                                        const componentes = Array.isArray(it.componentes) ? it.componentes : [];
                                        const abierto = !!paquetesExpandidos[it.key];

                                        return (
                                            <Fragment key={it.key}>
                                                <tr className={isUnder ? 'table-danger' : ''}>
                                                    <td className="text-center align-middle">
                                                        <button
                                                            type="button"
                                                            className="btn btn-sm btn-link p-0"
                                                            onClick={() => togglePaqueteExpandido(it.key)}
                                                            title={abierto ? 'Ocultar productos del paquete' : 'Ver productos del paquete'}
                                                        >
                                                            <i className={`fas fa-chevron-${abierto ? 'down' : 'right'}`} />
                                                        </button>
                                                    </td>
                                                    <td>
                                                        <div className="fw-semibold">{it.paqueteNombre}</div>
                                                        {it.paqueteCodigo ? (
                                                            <div className="text-muted" style={{ fontSize: 12 }}>{it.paqueteCodigo}</div>
                                                        ) : null}
                                                    </td>
                                                <td>
                                                    <CurrencyInput
                                                        value={it.precio}
                                                        decimalsLimit={3}
                                                        allowNegativeValue={false}
                                                        placeholder={`${prefMoneda} Venta`}
                                                        className="form-control"
                                                        prefix={`${prefMoneda} `}
                                                        groupSeparator=","
                                                        decimalSeparator="."
                                                        disabled={disabledAll}
                                                        onValueChange={(value) => {
                                                            const raw = value === undefined || value === null ? '' : value;
                                                            setPaqueteItemField(it.key, 'precio', raw);
                                                        }}
                                                    />
                                                </td>
                                                <td className="text-center align-middle">
                                                    <Form.Check
                                                        type="checkbox"
                                                        checked={!!it.iva}
                                                        disabled={disabledAll}
                                                        onChange={() => setPaqueteItemField(it.key, 'iva', !it.iva)}
                                                    />
                                                </td>
                                                <td>
                                                    <Form.Control
                                                        type="number"
                                                        value={it.cantidad}
                                                        min={esPaqueteOriginal ? pisoCantidad : 0}
                                                        placeholder="Cantidad"
                                                        disabled={disabledAll || totalDevuelto > 0}
                                                        className={isUnder ? 'is-invalid' : ''}
                                                        onChange={(e) => {
                                                            const v = e.target.value === '' ? 0 : Number(e.target.value);
                                                            setPaqueteItemField(it.key, 'cantidad', v);
                                                        }}
                                                    />
                                                    {isUnder ? (
                                                        <div className="invalid-feedback d-block">
                                                            No se puede reducir (usa devolución)
                                                        </div>
                                                    ) : null}
                                                    {devoluciones.length > 0 && (
                                                        <div className="mt-1">
                                                            {devoluciones.map((d, idx) => {
                                                                const destinosComponentes = Array.isArray(d?.componentes) ? d.componentes : [];
                                                                return (
                                                                <div key={idx} className="d-flex align-items-start justify-content-between text-muted" style={{ fontSize: 11 }}>
                                                                    <span>
                                                                        Devuelto {formatNumber(d?.cantidad)} paquete(s)
                                                                        {destinosComponentes.length > 0 && (
                                                                            <div style={{ fontSize: 10 }}>
                                                                                {destinosComponentes.map((dc, dcIdx) => {
                                                                                    const nombreProducto = (Array.isArray(it.componentes) ? it.componentes : [])
                                                                                        .find((c) => c.productoId === dc.productoId)?.productoNombre || dc.productoId;
                                                                                    const label = [dc?.area?.nombre, dc?.organizador?.nombre, dc?.ubicacion?.nombre].filter(Boolean).join(' / ') || 'Sin ubicación';
                                                                                    return (
                                                                                        <div key={dcIdx}>{nombreProducto} → {label}</div>
                                                                                    );
                                                                                })}
                                                                            </div>
                                                                        )}
                                                                    </span>
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-sm btn-link text-danger p-0 ms-1"
                                                                        title="Deshacer devolución"
                                                                        disabled={disabledAll}
                                                                        onClick={() => deshacerDevolucionPaquete(it.key, idx)}
                                                                    >
                                                                        <i className="fas fa-times" />
                                                                    </button>
                                                                </div>
                                                                );
                                                            })}
                                                        </div>
                                                    )}
                                                </td>
                                                <td className="align-middle">
                                                    <div className="fw-semibold">{prefMoneda} {formatMoney(subtotal)}</div>
                                                </td>
                                                <td className="text-center">
                                                    <div className="d-flex justify-content-center gap-2">
                                                        {esPaqueteOriginal && (
                                                            <Button
                                                                variant="outline-warning"
                                                                size="sm"
                                                                onClick={() => abrirDevolverPaquete(it)}
                                                                title={cantidad > originalCantidad
                                                                    ? 'No se puede devolver: ya se agregó cantidad extra a este paquete'
                                                                    : 'Devolver paquete'}
                                                                disabled={disabledAll || cantidad <= 0 || cantidad > originalCantidad}
                                                            >
                                                                <i className="fas fa-rotate-left" />
                                                            </Button>
                                                        )}
                                                        <Button
                                                            variant="danger"
                                                            size="sm"
                                                            onClick={() => eliminarPaqueteItem(it.key)}
                                                            title={esPaqueteOriginal ? 'Usa devolución para retirar este paquete' : 'Eliminar'}
                                                            disabled={disabledAll || esPaqueteOriginal}
                                                        >
                                                            <i className="fas fa-trash" />
                                                        </Button>
                                                    </div>
                                                </td>
                                            </tr>
                                            {abierto && (
                                                <tr>
                                                    <td />
                                                    <td colSpan={6} className="p-0">
                                                        <div className="table-responsive m-2">
                                                            <Table bordered size="sm" className="mb-0" style={{ fontSize: 13 }}>
                                                                <thead>
                                                                    <tr>
                                                                        <th>Producto</th>
                                                                        <th className="text-center" style={{ width: 130 }}>Cantidad</th>
                                                                        <th style={{ width: 150 }}>Unidad</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {componentes.length === 0 ? (
                                                                        <tr>
                                                                            <td colSpan={3} className="text-muted text-center">Sin productos</td>
                                                                        </tr>
                                                                    ) : componentes.map((c) => {
                                                                        const conversion = Number(c?.conversion || 1) || 1;
                                                                        const necesaria = (Number(c?.cantidadPorPaquete || 0) * cantidad) / conversion;

                                                                        return (
                                                                            <tr key={c.productoId}>
                                                                                <td>{c.productoNombre}</td>
                                                                                <td className="text-center">{formatNumber(necesaria)}</td>
                                                                                <td>{c.unidadNombre || '-'}</td>
                                                                            </tr>
                                                                        );
                                                                    })}
                                                                </tbody>
                                                            </Table>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )}
                                            </Fragment>
                                        );
                                    })}
                                </tbody>
                            </Table>
                        </div>
                    )}
                </Card.Body>
            </Card>

            <div className="d-flex justify-content-between align-items-center gap-2 flex-wrap">
                <div className="text-muted" style={{ fontSize: 13 }}>
                    {items.length > 0 ? `Productos: ${items.length}` : null}
                    {paquetesItems.length > 0 ? ` · Paquetes: ${paquetesItems.length}` : null}
                </div>

                <div className="d-flex gap-2">
                    {esCotizacionOriginal && !ventaEditadaLocal && (
                        <Button
                            variant="warning"
                            onClick={abrirConvertir}
                            disabled={disabledAll || guardandoConvertir || cargandoUbicacionesConvertir || (items.length === 0 && paquetesItems.length === 0)}
                        >
                            {cargandoUbicacionesConvertir ? 'Cargando ubicaciones...' : 'Convertir en venta'}
                        </Button>
                    )}

                    {!ventaEditadaLocal && (
                        <Button
                            variant="success"
                            onClick={editarVentaHandler}
                            disabled={disabledAll || guardandoConvertir}
                        >
                            {esCotizacion ? 'Guardar cotización' : 'Guardar venta'}
                        </Button>
                    )}

                    {ventaEditadaLocal && (
                        <Fragment>
                            <Button
                                variant="outline-secondary"
                                onClick={() => {
                                    setVentaEditadaLocal(null);
                                    dispatch(limpiarVentaEdicion());
                                    dispatch(cargarVentaEdicion(id));
                                }}
                            >
                                Seguir editando
                            </Button>
                            <Button
                                variant="secondary"
                                onClick={() => navigate('/ventas')}
                            >
                                Regresar
                            </Button>
                            <Button
                                variant="primary"
                                onClick={() => dispatch(generarPdfVenta(ventaEditadaLocal?._id))}
                            >
                                {esCotizacion ? 'Generar PDF cotización' : 'Generar PDF ticket'}
                            </Button>
                        </Fragment>
                    )}
                </div>
            </div>

            <AgregarClienteModal
                show={showNuevoCliente}
                onHide={() => setShowNuevoCliente(false)}
                onSave={guardarNuevoCliente}
                loading={savingCliente}
            />

            <PreciosProveedorModal
                show={showPreciosProveedor}
                onHide={cerrarPreciosProveedor}
                productoNombre={preciosContexto.productoNombre}
                codigoTienda={preciosContexto.codigoTienda}
                precios={preciosContexto.precios}
                moneda={moneda}
                tipoCambio={getTc()}
            />

            <SeleccionUbicacionesModal
                show={showUbicaciones}
                onHide={cerrarUbicaciones}
                onConfirm={onConfirmUbicaciones}
                producto={detalleActual}
                esCotizacion={esCotizacion}
                omitirUbicacion={esCotizacionOriginal}
                moneda={moneda}
                tipoCambio={getTc()}
            />

            <ConvertirVentaModal
                show={showConvertirModal}
                onHide={cerrarConvertir}
                onConfirm={confirmarConvertir}
                productos={productosConvertirDetalle}
                paquetes={paquetesConvertirDetalle}
                clienteLabel={clienteSeleccionado?.label}
                idCliente={clienteSeleccionado?.value || null}
                metodosOptions={metodosOptions}
                monedaDefault={moneda}
                tipoCambioDefault={tipoCambioUsd}
                loading={guardandoConvertir}
            />

            <DevolverProductoVentaModal
                show={showDevolverModal}
                onHide={cerrarDevolver}
                item={devolverContexto}
                onConfirm={confirmarDevolucion}
            />

            <SeleccionPaqueteModal
                show={showSeleccionPaquete}
                onHide={cerrarSeleccionPaquete}
                onConfirm={onConfirmPaquete}
                paquete={paqueteActual}
                esCotizacion={esCotizacion}
                moneda={moneda}
                tipoCambio={getTc()}
            />

            <DevolverPaqueteVentaModal
                show={showDevolverPaqueteModal}
                onHide={cerrarDevolverPaquete}
                item={devolverPaqueteContexto}
                onConfirm={confirmarDevolucionPaquete}
            />
        </Fragment>
    );
}
